module.exports = __webpack_public_path__ + "img/ai9@2x.b65a92cd.png";